
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jF1MT", function(module, exports) {

$parcel$export(module.exports, "LiveSearch", () => $530190fc1fa4bb04$export$55195ae4b8b092c1);

var $gwFzn = parcelRequire("gwFzn");

var $atveb = parcelRequire("atveb");

var $dIouf = parcelRequire("dIouf");

var $OEWWt = parcelRequire("OEWWt");

var $cqCFf = parcelRequire("cqCFf");
const $530190fc1fa4bb04$var$LiveSearchComponent = ({ macroNode: macroNode })=>{
    const [liveSearchOptions, setLiveSearchOptions] = (0, $gwFzn.useState)((0, $OEWWt.handleLiveSearchNode)(macroNode));
    (0, $gwFzn.useEffect)(()=>{
        setLiveSearchOptions((0, $OEWWt.handleLiveSearchNode)(macroNode));
    }, [
        macroNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cqCFf.LiveSearchTemplate), {
        config: liveSearchOptions
    });
};
const $530190fc1fa4bb04$export$55195ae4b8b092c1 = /*#__PURE__*/ (0, $gwFzn.memo)((0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).SMARTS
})($530190fc1fa4bb04$var$LiveSearchComponent), (0, (/*@__PURE__*/$parcel$interopDefault($atveb))));

});
parcelRegister("OEWWt", function(module, exports) {

$parcel$export(module.exports, "handleLiveSearchNode", () => $657adcdb840220fd$export$2176b31991c99d3d);
const $657adcdb840220fd$export$2176b31991c99d3d = (macroNode)=>{
    const macroParams = macroNode?.attrs?.parameters?.macroParams;
    return {
        labels: macroParams?.labels?.value,
        placeholder: macroParams?.placeholder?.value,
        size: macroParams?.size?.value,
        spaceKey: macroParams?.spaceKey?.value,
        type: macroParams?.type?.value,
        additional: macroParams?.additional?.value,
        macroId: macroNode?.attrs?.parameters?.macroMetadata?.macroId?.value
    };
};

});



//# sourceMappingURL=LiveSearch.ed055a5d.js.map
